import { CLIENTELE_AGE } from 'features/LeadGen/RetailerProfile/RetailerProfileEditMode/components/LocationWidgetEditMode/LocationWidgetEditMode.hooks'
import { RetailerProfileLocation } from 'features/LeadGen/RetailerProfile/retailerProfilePage.types'

export const getFormattedLocation = (location: RetailerProfileLocation) => {
  const formattedAddress = [location.address1, location.address2]
    .filter((addressElement) => Boolean(addressElement))
    .join(', ')
  const formattedLocationInfo = [
    location.city,
    location.state,
    location.country,
  ]
    .filter((addressElement) => Boolean(addressElement))
    .join(', ')
  return { formattedAddress, formattedLocationInfo }
}

export const getFullAddressText = (location: RetailerProfileLocation) => {
  const parts = [
    location.address1,
    location.address2,
    location.city,
    location.state,
    location.zip,
    location.country,
  ].filter((part): part is string => Boolean(part))
  const joined = parts.join(', ').trim()
  return joined || null
}

export const getGoogleMapsUrl = (location: RetailerProfileLocation) => {
  const fullAddress = getFullAddressText(location)
  if (!fullAddress) return null
  const query = [location.name, fullAddress].filter(Boolean).join(', ')
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`
}

export const useClienteleInfo = (
  clienteleInfo?: RetailerProfileLocation['clienteleInfo'] | null,
) => {
  const hasBasicInfo =
    Boolean(clienteleInfo?.male) ||
    Boolean(clienteleInfo?.female) ||
    Boolean(clienteleInfo?.age)
  const hasInfo =
    hasBasicInfo ||
    Boolean(clienteleInfo?.descriptions?.length) ||
    Boolean(clienteleInfo?.interests?.length)
  return {
    hasBasicInfo,
    hasInfo,
  }
}

export const getBasicInfoFormatted = (
  clienteleMale?: boolean | null,
  clienteleFemale?: boolean | null,
  clienteleAge?: string | null,
) => {
  const clienteleAllAges = CLIENTELE_AGE[4].value
  const clienteleAllAgesName = 'All Ages'
  const clienteleAgeNumber = clienteleAge?.split(' (')?.[0]
  const carriesMaleClientele = clienteleMale ? 'Male' : undefined
  const carriesFealeClientele = clienteleFemale ? 'Female' : undefined
  const cleanClienteleAge =
    clienteleAge === clienteleAllAges
      ? clienteleAllAgesName
      : clienteleAgeNumber

  const basicInfoFormatted = [
    carriesMaleClientele,
    carriesFealeClientele,
    cleanClienteleAge,
  ]
    .filter((info) => Boolean(info))
    .join(', ')

  return basicInfoFormatted
}

const mapToTrimmedDisplayItems = (
  items?: Array<{ name?: string | null } | null> | null,
): string[] =>
  (items ?? [])
    .map((item) => item?.name?.trim() ?? '')
    .filter((name) => name.length > 0)

export const getFormattedClienteleInfo = (
  clienteleInfo?: RetailerProfileLocation['clienteleInfo'] | null,
) => {
  const basicInfoFormatted = getBasicInfoFormatted(
    clienteleInfo?.male,
    clienteleInfo?.female,
    clienteleInfo?.age,
  )
  const clienteleDescriptionItems = mapToTrimmedDisplayItems(
    clienteleInfo?.descriptions,
  )
  const clienteleInterestItems = mapToTrimmedDisplayItems(
    clienteleInfo?.interests,
  )
  return {
    basicInfoFormatted,
    clienteleDescriptionItems,
    clienteleInterestItems,
  }
}
